import {
  sanitizeContent,
  sanitizePlainText,
  defaultSanitizeOptions,
} from "./ContentSanitizer";

export class DocumentMetadataSanitizer {
  static sanitizeDocumentUpdate(updates: {
    fileName?: string;
    documentType?: string;
    category?: string;
    description?: string;
    tags?: string[];
    expiryDate?: string;
    status?: "ACTIVE" | "INACTIVE" | "DELETED";
  }): typeof updates {
    const sanitized = { ...updates };

    if (sanitized.description) {
      sanitized.description =
        sanitizeContent(sanitized.description, {
          allowedTags: ["p", "br", "strong", "em"],
          allowedAttr: [],
          forbiddenTags: defaultSanitizeOptions.forbiddenTags,
          forbiddenAttr: defaultSanitizeOptions.forbiddenAttr,
        }) ?? undefined;
    }

    if (sanitized.tags && Array.isArray(sanitized.tags)) {
      sanitized.tags = sanitized.tags
        .map((tag) => sanitizePlainText(tag))
        .filter(
          (tag): tag is string =>
            tag !== null && tag.length > 0 && tag.length <= 50,
        );
    }

    if (sanitized.category) {
      sanitized.category = sanitized.category.replace(/[^a-zA-Z0-9_-]/g, "");
    }

    if (sanitized.documentType) {
      sanitized.documentType = sanitized.documentType.replace(
        /[^a-zA-Z0-9_-]/g,
        "",
      );
    }

    return sanitized;
  }

  static sanitizeDocumentForDisplay(document: any): any {
    if (!document) return document;

    return {
      ...document,
      fileName: document.fileName
        ? (sanitizePlainText(document.fileName) ?? undefined)
        : undefined,
      description: document.description
        ? (sanitizeContent(document.description, defaultSanitizeOptions) ??
          undefined)
        : undefined,
      tags: Array.isArray(document.tags)
        ? document.tags
            .map((tag: string) => sanitizePlainText(tag))
            .filter((tag: string | null): tag is string => tag !== null)
        : undefined,
    };
  }
}
